/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Game_Lemur_RelishInputs */

const fr_flat_game_lemur_relish = /** @type {(inputs: Flat_Game_Lemur_RelishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement validé`)
};

/**

* @param {Flat_Game_Lemur_RelishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const flat_game_lemur_relish = /** @type {((inputs?: Flat_Game_Lemur_RelishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Game_Lemur_RelishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_flat_game_lemur_relish(inputs)
});